var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"12","cy":"8","r":"4"}}),_c('path',{attrs:{"d":"M4 20a8 8 0 0 1 16 0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }